module.exports = __webpack_public_path__ + "static/img/plus.0e6a1019.png";